export const assetMap: Record<string, string> = {
  'sheet:mega': '/assets/rpg/originals/00_mega_asset_sheet.png',
  'sheet:congruence': '/assets/rpg/originals/01_congruencia_core.png',
  'sheet:cevians': '/assets/rpg/originals/02_cevianas.png',
  'sheet:congruence-cases': '/assets/rpg/originals/03_casos_congruencia_e_teoremas.png',
  'sheet:angles': '/assets/rpg/originals/04_angulos.png',
  'sheet:isosceles': '/assets/rpg/originals/05_triangulo_isosceles.png',
  'sheet:interface': '/assets/rpg/originals/06_interface_banners_divisores.png',
  'sheet:symbols': '/assets/rpg/originals/07_simbolos_marcadores.png',
  'sheet:encounters': '/assets/rpg/originals/08_exercicios_quests_bossproof.png',
  'angles-core': '/assets/rpg/originals/04_angulos.png',
  'congruence-core': '/assets/rpg/originals/01_congruencia_core.png',
  'congruence-cases': '/assets/rpg/originals/03_casos_congruencia_e_teoremas.png',
  'cevians-core': '/assets/rpg/originals/02_cevianas.png',
  'isosceles-core': '/assets/rpg/originals/05_triangulo_isosceles.png',
  'encounter-quest': '/assets/rpg/derived/quest-banner.png',
  'encounter-boss': '/assets/rpg/derived/boss-proof.png',
  'skill:sas': '/assets/rpg/derived/lal.png',
  'skill:asa': '/assets/rpg/derived/ala.png',
  'skill:sss': '/assets/rpg/derived/lll.png',
  'skill:median': '/assets/rpg/derived/mediana.png',
  'skill:angle-bisector': '/assets/rpg/derived/bissetriz.png',
  'skill:altitude': '/assets/rpg/derived/altura.png',
  'skill:isosceles-theorem': '/assets/rpg/derived/isosceles-base.png',
  'skill:isosceles-converse': '/assets/rpg/derived/isosceles-inverso.png',
  'skill:isosceles-special-cevian': '/assets/rpg/derived/isosceles-especial.png',
};
